export default __webpack_public_path__ + "da244dc22f7c4d34e27e251f8fc6dc35.svg";